module.exports = __webpack_public_path__ + "img/rocket.6b87ea8f.png";